/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import s from './Layout.scss';
import Navigation from '../Navigation';
import SaleNotification from '../SaleNotification';
import ChartLatestSales from '../ChartLatestSales';

class Layout extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    static contextTypes = {
        store: PropTypes.shape(),
    };

    // deffer rendering children page to increase loading other components (for example navigation active items)
    maybeRenderChildren() {
        const newPath = this.context.store.getState().path;

        // when changed path
        if (this.currentPath && this.currentPath !== newPath && window.requestAnimationFrame) {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    this.currentPath = newPath;
                    this.forceUpdate();
                });
            });
            return null;
        }
        this.currentPath = newPath;
        return this.props.children;
    }

    render() {
        const user = this.context.store.getState().user;
        const mobile_show_page = this.context.store.getState().settings.mobile_show_page;
        return (
            <div>
                {user ? (
                    <div className={s.side}>
                        <SaleNotification />
                        <Navigation />
                        <ChartLatestSales />
                    </div>
                ) : ''}
                <Scrollbars className={cx(s.page, mobile_show_page ? s.mobileShowPage : '')} autoHide universal>
                    <div className={s.wrap}>
                        {this.maybeRenderChildren()}
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

export default withStyles(s)(Layout);
